import { all } from 'redux-saga/effects'

import analysisSaga from './analysis'
import apiKeysSaga from './api_keys'
import appSaga from './app'
import authSaga from './auth'
import chartsSaga from './charts'
import configSaga from './config'
import customTagsSaga from './custom_tags'
import dashboardSaga from './dashboard'
import alertsSaga from './alerts'
import editMailingListSaga from './edit_mailing_list'
import editNewsSaga from './edit_news'
import environmentSaga from './environment'
import exportSaga from './export'
import filterTimelineSaga from './filter_timeline'
import gaSaga from './ga'
import gaioSaga from './gaio'
import identitySetsSaga from './identity_sets'
import influencersSaga from './influencers'
import mediaReviewSaga from './media_review'
import navigationSaga from './navigation'
import newsSaga from './news'
import pageIdentitiesSaga from './page_identities'
import publicationsSaga from './publications'
import savedDashboardSaga from './saved_dashboard'
import savedChartsSaga from './saved_charts'
import savedSearchesSaga from './saved_searches'
import savedSearchGroupsSaga from './saved_search_groups'
import shoppingCartSaga from './shopping_cart'
import shoppingNews from './shopping_news'
import subscriptionsSaga from './subscriptions'
import uiSaga from './ui'
import userSaga from './user'
import darknetSaga from './darknet'
import contentDeskSaga from './content_desk'
import contactManagementSaga from './contact_management'
import notificationsSaga from './notifications'
import surveySaga from './survey'
import anewstipSaga from './anewstip'
import emailTemplatesLibrarySaga from './email_templates_library'
import unsplashSaga from './unsplash'
import ustSaga from './ust'
import administrationSaga from './administration'
import themaxSaga from './themax'
import aiSaga from './ai'
import journalistsSaga from './journalists'
import promptHistorySaga from './prompt_history'
import helpCenterSaga from './help_center'
import personaLibrarySaga from './persona_library'

export default function* rootSaga() {
  yield all([
    alertsSaga(),
    analysisSaga(),
    apiKeysSaga(),
    appSaga(),
    authSaga(),
    chartsSaga(),
    configSaga(),
    customTagsSaga(),
    dashboardSaga(),
    editMailingListSaga(),
    editNewsSaga(),
    environmentSaga(),
    exportSaga(),
    filterTimelineSaga(),
    gaSaga(),
    gaioSaga(),
    identitySetsSaga(),
    influencersSaga(),
    mediaReviewSaga(),
    navigationSaga(),
    newsSaga(),
    pageIdentitiesSaga(),
    publicationsSaga(),
    savedDashboardSaga(),
    savedChartsSaga(),
    savedSearchesSaga(),
    savedSearchGroupsSaga(),
    shoppingCartSaga(),
    shoppingNews(),
    subscriptionsSaga(),
    uiSaga(),
    userSaga(),
    darknetSaga(),
    contentDeskSaga(),
    contactManagementSaga(),
    notificationsSaga(),
    unsplashSaga(),
    surveySaga(),
    anewstipSaga(),
    emailTemplatesLibrarySaga(),
    ustSaga(),
    administrationSaga(),
    themaxSaga(),
    aiSaga(),
    journalistsSaga(),
    helpCenterSaga(),
    promptHistorySaga(),
    personaLibrarySaga()
  ])
}
